<template>
  <div class="letter">
    <div class="epidmic-banner">
      <img src="@/assets/index/epidmedic/dp-top-banner.png" />
    </div>
    <div class="letter-box">
      <div class="letter-title">致全区各级党组织和广大党员干部的一封信</div>
      <div class="letter-source">
        <span>来源:微东坡</span>
        <span>2020年1月26日</span>
      </div>
      <div class="letter-content">
        <span>全区各级党组织和广大党员干部：</span>
        <p>当前，湖北省武汉市等多地陆续发生严重新型冠状病毒感染肺炎疫情，疫情时时刻刻牵动着大家的心。我区是眉山市政治、经济、文化中心，目前正值春节期间，人员大范围密集流动，防控形势十分严峻。为坚决遏制疫情蔓延势头，维护社会稳定，我们向全区各级党组织和全体党员干部发出号召，希望大家充分发挥先锋模范作用，众志成城，坚决打好打赢疫情防控这场硬战！</p>
        <p>
          <span>一、深入一线,勇于担当。一个支部就是一个战斗堡垒，一名党员就是一面鲜红的旗帜！</span>全区各级党组织要加强防控应急力量，增强值班值守，做好应急处置；广大党员同志，尤其是党员干部同志要学习钟南山院士“逆行而上”的坚守与担当，积极志愿加入防控队伍，深入一线、冲锋在前，让东坡区广大人民群众在疫情面前能够随时听到党组织的声音，看到党组织的行动，感受到党组织的温暖。
        </p>
        <p>
          <span>二、以身作则,率先垂范。大事难事看担当，困难和考验是检验初心和使命的试金石。</span> 当前，疫情防控仍处在重要的窗口期和黄金期，为了有效防止、阻断病毒的发生和蔓延，请广大党员干部尽量做到无事不出门，出门戴口罩，不集会、不聚餐、少握手、勤消毒、勤通风，拒野味、吃熟食，并注重个人防护，有发热干咳、呼吸困难等症状，及时到相关医院就诊。不信谣、不造谣、不传谣，一切以官方发布信息为准。
        </p>
        <p>
          <span>三、服务大局,积极作为。</span> 春节拜年、亲友聚餐是中国的传统，尽管我区目前尚未发现输入性新型冠状病毒感染的肺炎病例，但全国仍处于增长势头，部分群众还缺乏全面详细的防控知识，特别是传统的“酒桌文化”，天南海北的返乡人员、近距离的密切接触，觥筹交错中碗筷碰撞，可能就是病毒扩散传播的温床。全区广大党员同志要以“备战打仗”的心态和“尽锐出战 ”的作风，带头同不利于疫情防控的言行作斗争，积极通过手机短信、微信、微博等新媒体，让群众掌握防控知识，消除恐慌心态和侥幸心理。
        </p>
        <p>
          <span>疫情就是命令，旗帜彰显担当！让我们用实际行动诠释共产党员干部“平常时候看得出来、关键时刻站得出来、危急关头豁得出来”的光荣身份和精神风采，用使命担当为东坡百姓保驾护航！</span>
        </p>
        <p style="text-align: right; color: rgb(153, 153, 153);">中共眉山市东坡区委组织部</p>
        <p style="text-align: right; color: rgb(153, 153, 153);">2020年1月26日</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
<style lang='scss' scoped>
.letter {
  .letter-box {
    .letter-content {
      span {
        color: red;
      }
      p {
        text-indent: 0.6rem;
        margin: 0.3rem 0;
      }
      padding: 0.2rem 0.3rem 0 0.3rem;
    }
    .letter-source {
      span {
        margin-left: 0.3rem;
      }
      color: #999;
    }
    .letter-title {
      font-size: 0.34rem;
      font-weight: 700;
      text-align: center;
      line-height: 3;
    }
    background: #fff;
    width: 94%;
    position: absolute;
    left: 3%;
    top: 3.6rem;
    border-radius: 0.32rem;
  }
  .epidmic-banner {
    img {
      width: 100%;
    }
  }
  padding: 1rem 0;
  background: #fedfc9;
  font-size: 0.3rem;
}
</style>